import React from 'react';
import FormGroup from './FormGroup';

export interface FormButtonGroupButton {
  value: unknown;
  text: string;
}

export interface FormButtonGroupProps {
  buttons?: (FormButtonGroupButton | string)[];
  name?: string;
  label?: string;
  error?: unknown;
  errorMessage?: string;
  required?: boolean;
  extraRowClasses?: string;
  onChange?: (button: FormButtonGroupButton | string) => void;
  value?: unknown;
  register?: unknown;
  toggleGroupClassName?: string;
  helpContent?: React.ReactNode;
}

const FormButtonGroup = ({
  buttons = [],
  name,
  label,
  error,
  errorMessage,
  required,
  extraRowClasses = 'align-items-start',
  onChange,
  value,
  register,
  toggleGroupClassName,
  helpContent,
}: FormButtonGroupProps) => {
  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' && onChange) {
      const activeButton = buttons.find(
        (btn) => (typeof btn === 'object' ? btn.value : btn) === value
      );
      const activeIndex = activeButton !== undefined ? buttons.indexOf(activeButton) : -1;
      const nextIndex =
        activeIndex === buttons.length - 1 ? 0 : activeIndex + 1;
      const next = buttons[nextIndex];
      if (next !== undefined) onChange(next);
    }
  };

  return (
    <FormGroup
      label={label}
      error={Boolean(error)}
      errorMessage={errorMessage}
      required={required}
      extraRowClasses={extraRowClasses}
      helpContent={helpContent}
    >
      <div className={`toggle-group ${toggleGroupClassName}`}>
        {buttons.map((btn) => {
          return typeof btn === 'object' ? (
            <label
              key={String(btn.value)}
              className={value === btn.value ? 'checked' : ''}
              onClick={() => onChange?.(btn)}
              onKeyDown={(event: React.KeyboardEvent) => {
                if (event.key === 'Enter') {
                  onChange?.(btn);
                }
              }}
              tabIndex={0}
            >
              {btn.text}
            </label>
          ) : (
            <label
              key={String(btn)}
              className={value === btn ? 'checked' : ''}
              onClick={() => onChange?.(btn)}
              onKeyDown={(event: React.KeyboardEvent) => {
                if (event.key === 'Enter') {
                  onChange?.(btn);
                }
              }}
              tabIndex={0}
            >
              {btn}
            </label>
          );
        })}
      </div>
    </FormGroup>
  );
};
export default FormButtonGroup;
